/**
 * roman
 */
export const list_range_raw = [
	[
		[
			8544,
			8556
		]
	],
	[
		[
			8560,
			8572
		]
	]
];

/**
 * roman
 */
export const list_range = [
	[
		"Ⅰ",
		"Ⅱ",
		"Ⅲ",
		"Ⅳ",
		"Ⅴ",
		"Ⅵ",
		"Ⅶ",
		"Ⅷ",
		"Ⅸ",
		"Ⅹ",
		"Ⅺ",
		"Ⅻ"
	],
	[
		"ⅰ",
		"ⅱ",
		"ⅲ",
		"ⅳ",
		"ⅴ",
		"ⅵ",
		"ⅶ",
		"ⅷ",
		"ⅸ",
		"ⅹ",
		"ⅺ",
		"ⅻ"
	]
];

export default list_range;

